module.exports = __webpack_public_path__ + "media/Pill-TextEdit.20f246d6.mp4";